import Konva from 'konva';
import React, { forwardRef } from 'react';
import {Rect} from 'react-konva';

interface TextLineBackgroundInterface {
  y: number;
  width: number;
}

const TextLineBackground = forwardRef<Konva.Rect, TextLineBackgroundInterface>((props, ref) => {

  return (
    <Rect
      ref={ref}
      x={0}
      y={props.y}
      width={props.width + 5}
      height={18}
      fill="white"
      cornerRadius={4}
      opacity={0.7}
    />
  );
});

export default TextLineBackground;
